<div class="content">
  <form
    class="box"
    [class.dragging]="state === State.Dragging"
    (dragenter)="onDragEnter()"
    (dragleave)="onDragLeave()"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    >
    @switch (state) {
      @case (State.FileTypeError) {
        <div class="box__error">
          <h3>{{invalidTypes.size}} invalid file types provided</h3>
          <ul>
            @for (type of invalidTypes; track type) {
              <li>{{type}}</li>
            }
          </ul>
        </div>
      }
      @default {
        <div class="input">
          <img alt="Upload" src="/assets/default/cloud.svg" class="large-icon">
          <input hidden class="box__file" type="file" name="files[]" id="file"
            data-multiple-caption="{count} files selected" multiple #input
            [accept]="accept" (input)="onFileInput($event)"/>
          <label for="file"><strong (click)="input.click()">Choose a file</strong><span class="box__dragndrop"> or drag it here</span>.</label>
          <button class="btn btn-primary btn-medium" type="submit" (click)="input.click()">Upload</button>
        </div>
      }
    }
  </form>
</div>
